// ============================================
// ФОРМА СКАЧИВАНИЯ БРОШЮРЫ
// ============================================

// Убеждаемся, что checkAntibot доступна (если validation.js еще не загружен)
if (typeof window.checkAntibot !== 'function') {
  window.checkAntibot = function(userAnswer, correctAnswer) {
    if (!userAnswer || !userAnswer.trim()) return false;
    const answer = parseInt(userAnswer.trim(), 10);
    if (isNaN(answer)) return false;
    return answer === correctAnswer;
  };
}

// Элементы формы
const downloadForm = document.querySelector(".download_form");
const phoneDownload = downloadForm ? downloadForm.querySelector('#phone') : null;
const antibotBlock7 = document.getElementById('antibotBlock7');
const antibotLabelBlock7 = document.getElementById('antibotLabelBlock7');
const downloadBtn = document.querySelector('.download_btn');

// Изначально отключаем кнопку (как в других формах)
if (downloadBtn) {
  downloadBtn.disabled = true;
  downloadBtn.style.opacity = '0.5';
  downloadBtn.style.cursor = 'not-allowed';
}

// Инициализация антибота для формы брошюры (как в формах 3 и 4)
// Инициализируем при загрузке DOM, так как элементы могут быть еще не созданы
let antibot7;

// Функция обновления состояния кнопки Скачать в block7 (как в других формах)
function updateBlock7DownloadButton() {
  if (!downloadBtn || !phoneDownload) return;
  
  const phoneValue = phoneDownload.value.trim();
  // Используем validateBlock7Phone, если доступна, иначе проверяем количество цифр вручную
  let isPhoneValid = false;
  if (typeof window.validateBlock7Phone === 'function') {
    isPhoneValid = window.validateBlock7Phone(phoneValue);
  } else {
    // Fallback: проверяем количество цифр вручную
    const phoneCodeBlock7 = document.getElementById("phoneCodeBlock7");
    const code = phoneCodeBlock7 ? phoneCodeBlock7.textContent.trim() : '+7';
    const isUzbekistan = code === '+998';
    const digitsOnly = phoneValue.replace(/\D/g, '');
    const requiredDigits = isUzbekistan ? 9 : 10;
    isPhoneValid = digitsOnly.length === requiredDigits;
  }
  
  const nameInput = document.getElementById('name');
  const emailInput = document.getElementById('email');
  const campusInput = document.getElementById('campus');
  
  const isNameValid = nameInput && nameInput.value.trim() !== '';
  const isEmailValid = emailInput && emailInput.value.trim() !== '' && emailInput.value.includes('@');
  const isCampusValid = campusInput && campusInput.value.trim() !== '';
  
  // Проверяем антибот всегда, независимо от ширины экрана (как в других формах)
  let isAntibotValid = false;
  if (antibotBlock7) {
    const antibotValue = antibotBlock7.value.trim();
    const currentAntibot = typeof antibot7 !== 'undefined' ? antibot7 : (typeof window.antibot7 !== 'undefined' ? window.antibot7 : null);
    if (antibotValue && currentAntibot) {
      // Используем checkAntibot из window, если доступна, иначе проверяем вручную
      const checkFn = typeof window.checkAntibot === 'function' ? window.checkAntibot : null;
      if (checkFn) {
        isAntibotValid = checkFn(antibotValue, currentAntibot.answer);
      } else {
        // Fallback: простая проверка
        const answer = parseInt(antibotValue, 10);
        isAntibotValid = !isNaN(answer) && answer === currentAntibot.answer;
      }
    }
  }
  
  // Кнопка активна только если все поля валидны, включая антибот
  if (isNameValid && isEmailValid && isPhoneValid && isCampusValid && isAntibotValid) {
    downloadBtn.disabled = false;
    downloadBtn.style.opacity = '1';
    downloadBtn.style.cursor = 'pointer';
  } else {
    downloadBtn.disabled = true;
    downloadBtn.style.opacity = '0.5';
    downloadBtn.style.cursor = 'not-allowed';
  }
}

// Функция для обновления placeholder и ограничений для телефона в block7
function updateBlock7PhoneLimits() {
  if (!phoneDownload) return;
  
  const phoneCodeBlock7 = document.getElementById("phoneCodeBlock7");
  if (!phoneCodeBlock7) return;
  
  const code = phoneCodeBlock7.textContent.trim();
  const isUzbekistan = code === '+998';
  const maxDigits = isUzbekistan ? 9 : 10;
  const placeholder = isUzbekistan ? '99 999 99 99' : '999 999 99 99';
  
  // Устанавливаем maxlength для ограничения ввода (учитываем пробелы)
  const maxLength = isUzbekistan ? 13 : 13; // 9 цифр + 3 пробела = 12, но используем 13 для единообразия, 10 цифр + 3 пробела = 13
  phoneDownload.setAttribute('maxlength', maxLength);
  phoneDownload.placeholder = placeholder;
  
  // Удаляем старые обработчики, если они есть
  if (phoneDownload.dataset.limitHandler) {
    phoneDownload.removeEventListener('input', phoneDownload._limitHandler);
    phoneDownload.removeEventListener('paste', phoneDownload._pasteHandler);
  }
  
  // Создаем обработчик для ограничения ввода только цифрами
  const limitHandler = function(e) {
    let value = e.target.value.replace(/\D/g, ''); // Убираем все нецифровые символы
    
    // Определяем регион по текущему коду страны
    const currentCode = phoneCodeBlock7 ? phoneCodeBlock7.textContent.trim() : '';
    const isUz = currentCode === '+998';
    const maxDig = isUz ? 9 : 10;
    
    // Строго ограничиваем количество цифр
    if (value.length > maxDig) {
      value = value.slice(0, maxDig);
    }
    
    // Форматируем номер с пробелами
    let formatted = '';
    if (isUz) {
      // Формат для Узбекистана: 99 999 99 99
      if (value.length > 7) {
        formatted = value.slice(0, 2) + ' ' + value.slice(2, 5) + ' ' + value.slice(5, 7) + ' ' + value.slice(7);
      } else if (value.length > 5) {
        formatted = value.slice(0, 2) + ' ' + value.slice(2, 5) + ' ' + value.slice(5);
      } else if (value.length > 2) {
        formatted = value.slice(0, 2) + ' ' + value.slice(2);
      } else {
        formatted = value;
      }
    } else {
      // Формат для России: 999 999 99 99
      if (value.length > 8) {
        formatted = value.slice(0, 3) + ' ' + value.slice(3, 6) + ' ' + value.slice(6, 8) + ' ' + value.slice(8);
      } else if (value.length > 6) {
        formatted = value.slice(0, 3) + ' ' + value.slice(3, 6) + ' ' + value.slice(6);
      } else if (value.length > 3) {
        formatted = value.slice(0, 3) + ' ' + value.slice(3);
      } else {
        formatted = value;
      }
    }
    
    e.target.value = formatted;
  };
  
  // Обработчик для вставки текста
  const pasteHandler = function(e) {
    e.preventDefault();
    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
    const digitsOnly = pastedText.replace(/\D/g, '');
    
    const currentCode = phoneCodeBlock7 ? phoneCodeBlock7.textContent.trim() : '';
    const isUz = currentCode === '+998';
    const maxDig = isUz ? 9 : 10;
    
    // Ограничиваем количество цифр
    const limitedDigits = digitsOnly.slice(0, maxDig);
    
    // Форматируем
    let formatted = '';
    if (isUz) {
      if (limitedDigits.length > 6) {
        formatted = limitedDigits.slice(0, 3) + ' ' + limitedDigits.slice(3, 6) + ' ' + limitedDigits.slice(6);
      } else if (limitedDigits.length > 3) {
        formatted = limitedDigits.slice(0, 3) + ' ' + limitedDigits.slice(3);
      } else {
        formatted = limitedDigits;
      }
    } else {
      if (limitedDigits.length > 8) {
        formatted = limitedDigits.slice(0, 3) + ' ' + limitedDigits.slice(3, 6) + ' ' + limitedDigits.slice(6, 8) + ' ' + limitedDigits.slice(8);
      } else if (limitedDigits.length > 6) {
        formatted = limitedDigits.slice(0, 3) + ' ' + limitedDigits.slice(3, 6) + ' ' + limitedDigits.slice(6);
      } else if (limitedDigits.length > 3) {
        formatted = limitedDigits.slice(0, 3) + ' ' + limitedDigits.slice(3);
      } else {
        formatted = limitedDigits;
      }
    }
    
    e.target.value = formatted;
  };
  
  // Сохраняем ссылки на обработчики
  phoneDownload._limitHandler = limitHandler;
  phoneDownload._pasteHandler = pasteHandler;
  phoneDownload.dataset.limitHandler = 'true';
  
  // Добавляем обработчики
  phoneDownload.addEventListener('input', limitHandler);
  phoneDownload.addEventListener('paste', pasteHandler);
}

// Кастомный select для кампуса в форме (block7)
// Маппинг ID кампуса (из БД) -> slug для поиска переводов
const formCampusIdToSlug = {
  '1': 'spb',
  '2': 'moscow',
  '3': 'gorki',
  '4': 'tashkent',
  '5': 'skolkovo',
};
const formCampusNames = {
  skolkovo: "Сколково",
  moscow: "Москва",
  gorki: "Горки",
  spb: "Санкт-Петербург",
  tashkent: "Ташкент",
  '5': 'Сколково',
  '2': 'Москва',
  '3': 'Горки',
  '1': 'Санкт-Петербург',
  '4': 'Ташкент',
};

function getFormCampusTranslationKey(value) {
  return formCampusIdToSlug[value] || value;
}
window.getFormCampusTranslationKey = getFormCampusTranslationKey;

/** Скрытое поле — всегда numeric campus id; в UI/регионе может прийти slug (tashkent и т.д.) */
function resolveFormCampusStorageValue(value, formCampusModal) {
  if (value === undefined || value === null || value === "") return value;
  const str = String(value);
  if (!formCampusModal) return str;
  if (formCampusModal.querySelector(`.form_campus_option[data-value="${str}"]`)) {
    return str;
  }
  const bySlug = formCampusModal.querySelector(`.form_campus_option[data-slug="${str}"]`);
  if (bySlug) return String(bySlug.getAttribute("data-value"));
  return str;
}

// Функция для обновления переводов опций кампусов в форме block7
function updateBlock7CampusTranslations() {
  const formCampusModal = document.getElementById("formCampusModal");
  const formSelectedCampus = document.getElementById("formSelectedCampus");
  const formCampusInput = document.getElementById("campus");
  
  if (!formCampusModal) return;
  
  // Получаем текущий язык и переводы
  const currentLang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
  
  if (!t) return;
  
  // Обновляем опции в выпадающем меню (переводы по slug)
  const formCampusOptions = formCampusModal.querySelectorAll(".form_campus_option");
  formCampusOptions.forEach(option => {
    const dataValue = option.getAttribute("data-value");
    const translationKey = getFormCampusTranslationKey(dataValue);
    if (dataValue && t[`campus_name_${translationKey}`]) {
      option.textContent = t[`campus_name_${translationKey}`];
    }
  });
  
  // Обновляем выбранный кампус в кнопке
  if (formSelectedCampus && formCampusInput) {
    const campusValue = formCampusInput.value;
    const translationKey = getFormCampusTranslationKey(campusValue);
    if (campusValue && t[`campus_name_${translationKey}`]) {
      formSelectedCampus.textContent = t[`campus_name_${translationKey}`];
    }
  }
}

// Экспортируем функцию глобально
window.updateBlock7CampusTranslations = updateBlock7CampusTranslations;

function selectFormCampus(value, formSelectedCampus, formCampusInput, formCampusModal, formCampusBtn) {
  const storageValue = resolveFormCampusStorageValue(value, formCampusModal);

  // Получаем перевод в зависимости от текущего языка (переводы по slug)
  const currentLang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
  const translationKey = getFormCampusTranslationKey(storageValue);
  const campusName = t && t[`campus_name_${translationKey}`] ? t[`campus_name_${translationKey}`] : formCampusNames[storageValue] || formCampusNames[translationKey];

  
  if (!campusName) {
    console.error("Campus name not found for value:", value);
    return;
  }
  
  // Убираем класс selected со всех опций
  if (formCampusModal) {
    const allOptions = formCampusModal.querySelectorAll(".form_campus_option");
    allOptions.forEach(option => {
      option.classList.remove("selected");
    });
    
    // Добавляем класс selected к выбранной опции
    const selectedOption = formCampusModal.querySelector(`.form_campus_option[data-value="${storageValue}"]`);
    if (selectedOption) {
      selectedOption.classList.add("selected");
    }
  }
  
  if (formSelectedCampus) {
    formSelectedCampus.textContent = campusName;

  } else {
    console.error("formSelectedCampus is null");
  }
  
  if (formCampusInput) {
    formCampusInput.value = storageValue;

  } else {
    console.error("formCampusInput is null");
  }
  
  // Закрываем модальное окно
  if (formCampusModal) {
    formCampusModal.classList.remove("open");
  }
  if (formCampusBtn) {
    formCampusBtn.classList.remove("menu-open");
  }
  
  // Обновляем кнопку после выбора кампуса
  updateBlock7DownloadButton();
}

// Инициализация Phone Flag Selector для block7
function initBlock7PhoneFlagSelector() {
  const phoneFlagSelectorBlock7 = document.getElementById("phoneFlagSelectorBlock7");
  const phoneModalBlock7 = document.getElementById("phoneModalBlock7");
  const phoneCodeBlock7 = document.getElementById("phoneCodeBlock7");
  const phoneFlagImgBlock7 = document.getElementById("phoneFlagImgBlock7");
  const setBlock7EmojiFlag = (countryIso) => {
    if (typeof window.ensurePhoneFlagEmojiElement === 'function') {
      window.ensurePhoneFlagEmojiElement("phoneFlagImgBlock7", countryIso);
      return;
    }
    const currentFlag = document.getElementById("phoneFlagImgBlock7");
    if (!currentFlag) return;
    const emoji = window.getCountryFlagEmoji ? window.getCountryFlagEmoji(countryIso) : "🏳";
    if (currentFlag.tagName === "SPAN") {
      currentFlag.classList.add("flag-emoji", "phoneFlagImg");
      currentFlag.textContent = emoji;
      return;
    }
    const parent = currentFlag.parentNode;
    if (!parent) return;
    const emojiSpan = document.createElement("span");
    emojiSpan.className = "flag-emoji phoneFlagImg";
    emojiSpan.id = "phoneFlagImgBlock7";
    emojiSpan.textContent = emoji;
    parent.replaceChild(emojiSpan, currentFlag);
  };

  if (!phoneFlagSelectorBlock7 || !phoneModalBlock7) return;
  
  // Определяем регион для установки узбекского номера по умолчанию
  const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
    ? window.getCookie(window.COOKIE_NAME)
    : (typeof getCookie === 'function' && typeof COOKIE_NAME !== 'undefined' ? getCookie(COOKIE_NAME) : null);
  let currentRegion = 'Россия';
  if (saved) {
    try {
      const regionData = JSON.parse(saved);
      currentRegion = regionData.name;
    } catch (e) {
      // Если не удалось распарсить, используем значение по умолчанию
    }
  }
  
  const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
  
  // Если Узбекистан, устанавливаем узбекский номер по умолчанию
  if (phoneCodeBlock7 && phoneFlagImgBlock7) {
    if (isUzbekistan) {
      phoneCodeBlock7.textContent = '+998';
      setBlock7EmojiFlag('uz');
    } else {
      phoneCodeBlock7.textContent = '+7';
      setBlock7EmojiFlag('ru');
    }
    // Обновляем ограничения для телефона
    if (typeof window.updateBlock7PhoneLimits === 'function') {
      window.updateBlock7PhoneLimits();
    }
  }
  
  // Генерируем список стран динамически, если он еще не создан
  const phoneCountryOptionsContainerBlock7 = phoneModalBlock7.querySelector(".phone_country_options");
  
  // Убеждаемся, что кнопка закрытия всегда есть в заголовке
  const phoneCloseBtnBlock7 = typeof window.ensureCloseButtonInHeader === 'function'
    ? window.ensureCloseButtonInHeader(phoneModalBlock7)
    : null;
  
  // Проверяем количество существующих опций стран (не считая кнопку закрытия)
  const existingOptionsBlock7 = phoneCountryOptionsContainerBlock7 ? phoneCountryOptionsContainerBlock7.querySelectorAll(".phone_country_option") : [];
  
  // Проверяем, нужно ли генерировать список стран (если меньше 10 стран, значит нужно добавить все)
  if (phoneCountryOptionsContainerBlock7 && window.countryCodesData && existingOptionsBlock7.length < 10) {
    phoneCountryOptionsContainerBlock7.innerHTML = '';
    
    // Генерируем опции для всех стран
    window.countryCodesData.forEach(country => {
      const option = document.createElement('div');
      option.className = 'phone_country_option';
      option.setAttribute('data-country', country.country);
      option.setAttribute('data-code', country.code);
      option.setAttribute('data-flag', 'emoji');
      option.setAttribute('data-placeholder', country.placeholder);

      option.innerHTML = `
        <span class="flag-emoji">${window.getCountryFlagEmoji(country.country)}</span>
        <span>${country.code}</span>
      `;
      phoneCountryOptionsContainerBlock7.appendChild(option);
    });
  }
  
  const phoneModalHeaderBlock7 = phoneModalBlock7.querySelector(".phone_modal_header");
  const phoneCloseBtnBlock7New = phoneCloseBtnBlock7 || (phoneModalHeaderBlock7 ? phoneModalHeaderBlock7.querySelector(".phone_close_btn") : null);

  function openPhoneModalBlock7() {
    if (phoneModalBlock7) phoneModalBlock7.classList.add("open");
    if (phoneFlagSelectorBlock7) phoneFlagSelectorBlock7.classList.add("active");
  }

  function closePhoneModalBlock7() {
    if (phoneModalBlock7) phoneModalBlock7.classList.remove("open");
    if (phoneFlagSelectorBlock7) phoneFlagSelectorBlock7.classList.remove("active");
  }

  phoneFlagSelectorBlock7.addEventListener("click", (e) => {
    // Проверяем, что клик не на phone_modal_wrapper или его дочерних элементах
    const phoneModalWrapper = phoneFlagSelectorBlock7.querySelector('.phone_modal_wrapper');
    if (phoneModalWrapper && (phoneModalWrapper.contains(e.target) || e.target === phoneModalWrapper)) {
      return;
    }
    e.stopPropagation();
    phoneModalBlock7.classList.toggle("open");
    phoneFlagSelectorBlock7.classList.toggle("active");
  });

  // Делегирование: ловим клики на любых опциях (включая динамически добавленные)
  if (phoneCountryOptionsContainerBlock7 && !phoneCountryOptionsContainerBlock7.dataset.clickHandlerAttached) {
    phoneCountryOptionsContainerBlock7.addEventListener("click", (e) => {
      const option = e.target.closest(".phone_country_option");
      if (!option) return;
      
      e.stopPropagation();
      if (e.target.classList.contains("phone_close_btn") || e.target.closest(".phone_close_btn")) {
        return;
      }
      
      const country = option.dataset.country;
      const code = option.dataset.code;
      const placeholder = option.dataset.placeholder || '';

      if (phoneCodeBlock7) phoneCodeBlock7.textContent = code;
      
      // Берём актуальный элемент из DOM — после replaceChild переменная устаревает
      setBlock7EmojiFlag(country);
      // Очищаем поле телефона при смене кода страны и обновляем placeholder
      const phoneInput = phoneCodeBlock7 ? phoneCodeBlock7.closest('.phone_wrapper')?.querySelector('input[type="tel"]') : null;
      if (phoneInput) {
        phoneInput.value = '';
        if (placeholder) {
          phoneInput.placeholder = placeholder;
        }
        phoneInput.dataset.countryCode = code;
      }
      updateBlock7PhoneLimits();
      closePhoneModalBlock7();
      updateBlock7DownloadButton();
    });
    phoneCountryOptionsContainerBlock7.dataset.clickHandlerAttached = 'true';
  }

  // Используем делегирование событий для кнопки закрытия (работает с динамически созданными кнопками)
  if (phoneModalHeaderBlock7) {
    phoneModalHeaderBlock7.addEventListener("click", (e) => {
      if (e.target.classList.contains("phone_close_btn") || e.target.closest(".phone_close_btn")) {
        e.stopPropagation();
        e.preventDefault();
        closePhoneModalBlock7();
      }
    });
  }
  
  // Также привязываем обработчик напрямую к существующей кнопке
  const closeBtnToUse = phoneCloseBtnBlock7New || phoneCloseBtnBlock7;
  if (closeBtnToUse) {
    closeBtnToUse.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
      closePhoneModalBlock7();
    });
  }
  
  // Добавляем валидацию для поля телефона
  const phoneInputBlock7 = phoneCodeBlock7?.closest('.phone_wrapper')?.querySelector('input[type="tel"]');
  if (phoneInputBlock7 && typeof window.validatePhoneNumber === 'function') {
    phoneInputBlock7.addEventListener('blur', function() {
      const countryCode = this.dataset.countryCode || phoneCodeBlock7?.textContent;
      if (countryCode && this.value.trim()) {
        const validation = window.validatePhoneNumber(this.value, countryCode);
        if (!validation.valid) {
          this.setCustomValidity(validation.message);
          this.reportValidity();
        } else {
          this.setCustomValidity('');
        }
      }
    });
    
    phoneInputBlock7.addEventListener('input', function() {
      // Очищаем ошибку при вводе
      if (this.validity.customError) {
        this.setCustomValidity('');
      }
    });
  }

  // Закрытие модального окна при клике вне его
  document.addEventListener("click", (e) => {
    if (phoneModalBlock7 && phoneModalBlock7.classList.contains("open")) {
      if (!phoneFlagSelectorBlock7.contains(e.target)) {
        closePhoneModalBlock7();
      }
    }
  });
}

// Инициализация формы block7
function initDownloadBrochureFormBlock7() {
  // Инициализируем антибот для формы брошюры (как в формах 3 и 4)
  function initAntibot7() {
    const antibotLabelBlock7El = document.getElementById('antibotLabelBlock7');
    if (!antibotLabelBlock7El) return false;
    
    const generateFn = typeof generateAntibot === 'function' ? generateAntibot : 
                       (typeof window.generateAntibot === 'function' ? window.generateAntibot : null);
    const updateFn = typeof updateAntibotLabel === 'function' ? updateAntibotLabel : 
                     (typeof window.updateAntibotLabel === 'function' ? window.updateAntibotLabel : null);
    
    if (generateFn && updateFn) {
      antibot7 = generateFn();
      updateFn(antibotLabelBlock7El, antibot7);
      antibotLabelBlock7El.setAttribute('data-answer', antibot7.answer);
      // Делаем переменную глобально доступной
      window.antibot7 = antibot7;
      return true;
    }
    return false;
  }
  
  // Пробуем инициализировать сразу
  if (!initAntibot7()) {
    // Если не получилось, пробуем через небольшую задержку (функции могут еще загружаться)
    let attempts = 0;
    const maxAttempts = 20;
    const tryInit = setInterval(() => {
      if (initAntibot7() || attempts >= maxAttempts) {
        clearInterval(tryInit);
      }
      attempts++;
    }, 100);
  }
  
  // Ждем загрузки данных стран, если они еще не загружены
  if (!window.countryCodesData) {
    setTimeout(() => {
      initBlock7PhoneFlagSelector();
    }, 100);
  } else {
    // Инициализация Phone Flag Selector для block7
    initBlock7PhoneFlagSelector();
  }
  
  // Инициализация ограничений для телефона
  if (phoneDownload) {
    updateBlock7PhoneLimits();
    
    // Обработчик для проверки при потере фокуса
    phoneDownload.addEventListener('blur', (e) => {
      const value = e.target.value;
      if (value && typeof window.validateBlock7Phone === 'function' && !window.validateBlock7Phone(value)) {
        e.target.classList.add('error');
      } else {
        e.target.classList.remove('error');
      }
    });
  }
  
  // Добавляем обработчики для валидации в block7
  if (phoneDownload) {
    phoneDownload.addEventListener('input', updateBlock7DownloadButton);
    phoneDownload.addEventListener('blur', updateBlock7DownloadButton);
  }

  if (antibotBlock7) {
    antibotBlock7.addEventListener('input', updateBlock7DownloadButton);
    antibotBlock7.addEventListener('blur', updateBlock7DownloadButton);
  }

  const nameInputBlock7 = document.getElementById('name');
  const emailInputBlock7 = document.getElementById('email');
  const campusInputBlock7 = document.getElementById('campus');

  if (nameInputBlock7) {
    nameInputBlock7.addEventListener('input', updateBlock7DownloadButton);
    nameInputBlock7.addEventListener('blur', updateBlock7DownloadButton);
  }

  if (emailInputBlock7) {
    emailInputBlock7.addEventListener('input', updateBlock7DownloadButton);
    emailInputBlock7.addEventListener('blur', updateBlock7DownloadButton);
  }

  if (campusInputBlock7) {
    campusInputBlock7.addEventListener('change', updateBlock7DownloadButton);
  }

  // Инициализация кнопки при загрузке (как в форме 1)
  // Кнопка уже disabled по умолчанию в HTML и при загрузке скрипта
  // Обновляем состояние несколько раз с задержками, чтобы убедиться, что все элементы готовы
  if (downloadBtn && phoneDownload && antibotBlock7) {
    setTimeout(() => {
      updateBlock7DownloadButton();
    }, 300);
    setTimeout(() => {
      updateBlock7DownloadButton();
    }, 600);
    setTimeout(() => {
      updateBlock7DownloadButton();
    }, 1000);
  }

  // Обработка отправки формы
  const setBrochureSubmitting = (isSubmitting) => {
    if (downloadBtn) downloadBtn.disabled = isSubmitting;
    const loader = downloadForm ? downloadForm.querySelector('.download_loader') : null;
    if (loader) loader.style.display = isSubmitting ? 'block' : 'none';
  };

  if (downloadForm) {
    downloadForm.addEventListener("submit", (e) => {
      // Валидация телефона
      if (!phoneDownload || (typeof window.validateBlock7Phone === 'function' && !window.validateBlock7Phone(phoneDownload.value))) {
        const phoneCodeBlock7 = document.getElementById("phoneCodeBlock7");
        const code = phoneCodeBlock7 ? phoneCodeBlock7.textContent.trim() : '+7';
        const isUzbekistan = code === '+998';
        const requiredDigits = isUzbekistan ? 9 : 10;
        alert(`Пожалуйста, введите корректный номер телефона (${requiredDigits} цифр)`);
        if (phoneDownload) {
          phoneDownload.focus();
          phoneDownload.classList.add('error');
        }
        e.preventDefault();
        return;
      }
      
      // Валидация антибота (как в других формах)
      if (antibotBlock7) {
        const antibotValue = antibotBlock7.value.trim();
        const currentAntibot = typeof antibot7 !== 'undefined' ? antibot7 : (typeof window.antibot7 !== 'undefined' ? window.antibot7 : null);
        // Используем checkAntibot из window, если доступна, иначе проверяем вручную
        const checkFn = typeof window.checkAntibot === 'function' ? window.checkAntibot : null;
        let isAntibotValid = false;
        if (antibotValue && currentAntibot) {
          if (checkFn) {
            isAntibotValid = checkFn(antibotValue, currentAntibot.answer);
          } else {
            // Fallback: простая проверка
            const answer = parseInt(antibotValue, 10);
            isAntibotValid = !isNaN(answer) && answer === currentAntibot.answer;
          }
        }
        if (!antibotValue || !currentAntibot || !isAntibotValid) {
          alert('Пожалуйста, правильно ответьте на вопрос антибота');
          if (antibotBlock7) {
            antibotBlock7.focus();
            antibotBlock7.classList.add('error');
            // Генерируем новый антибот
            if (typeof generateAntibot === 'function' && typeof updateAntibotLabel === 'function') {
              antibot7 = generateAntibot();
              window.antibot7 = antibot7;
              const antibotLabelBlock7El = document.getElementById('antibotLabelBlock7');
              if (antibotLabelBlock7El) {
                updateAntibotLabel(antibotLabelBlock7El, antibot7);
                antibotLabelBlock7El.setAttribute('data-answer', antibot7.answer);
              }
            }
            antibotBlock7.value = '';
          }
          e.preventDefault();
          return;
        }
      }
      
      
      if (phoneDownload) {
        phoneDownload.classList.remove('error');
      }
      
      setBrochureSubmitting(true);
    });

    document.addEventListener('ajax:complete', (event) => {
      const target = event.target;
      if (target !== downloadForm) return;
      setBrochureSubmitting(false);
    });
  }

  // Кастомный select для кампуса в форме (block7)
  const formCampusBtn = document.getElementById("formCampusBtn");
  const formCampusModal = document.getElementById("formCampusModal");
  const formSelectedCampus = document.getElementById("formSelectedCampus");
  const formCampusInput = document.getElementById("campus");
  
  if (!formCampusBtn || !formCampusModal) {
    // The brochure form is not present on every page.
    return;
  }

  // Выбираем все опции заново внутри DOMContentLoaded
  const formCampusOptions = formCampusModal.querySelectorAll(".form_campus_option");

  
  formCampusOptions.forEach((option, index) => {
    const value = option.getAttribute("data-value");

  });

  // Инициализируем выбранный элемент при загрузке
  if (formCampusInput && formCampusInput.value) {
    const initialValue = formCampusInput.value;
    const initialOption = formCampusModal.querySelector(`.form_campus_option[data-value="${initialValue}"]`);
    if (initialOption) {
      initialOption.classList.add("selected");
    }
  }
  
  // Обновляем переводы кампусов при инициализации
  updateBlock7CampusTranslations();
  
  formCampusBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    formCampusModal.classList.toggle("open");
    formCampusBtn.classList.toggle("menu-open");
  });

  // Привязываем обработчики напрямую к каждому элементу опции
  formCampusOptions.forEach((option, index) => {
    // Добавляем уникальный идентификатор для отладки
    option.setAttribute("data-option-index", index);
    
    // Обработчик click
    const clickHandler = (e) => {
      e.stopPropagation();
      e.preventDefault();
      const value = option.getAttribute("data-value");
      const optionIndex = option.getAttribute("data-option-index");

      if (value && formCampusNames[value]) {

        selectFormCampus(value, formSelectedCampus, formCampusInput, formCampusModal, formCampusBtn);
      } else {
        console.error("Value not found or not in formCampusNames:", value);
      }
      return false;
    };
    
    option.addEventListener("click", clickHandler, { capture: true });
    option.addEventListener("click", clickHandler, { capture: false });
    
    // Также добавляем mousedown для надежности
    const mousedownHandler = (e) => {
      e.stopPropagation();
      e.preventDefault();
      const value = option.getAttribute("data-value");
      const optionIndex = option.getAttribute("data-option-index");

      if (value && formCampusNames[value]) {
        selectFormCampus(value, formSelectedCampus, formCampusInput, formCampusModal, formCampusBtn);
      }
      return false;
    };
    
    option.addEventListener("mousedown", mousedownHandler, { capture: true });
    option.addEventListener("mousedown", mousedownHandler, { capture: false });
    

  });

  // Делегирование событий на модальном окне как резервный вариант
  formCampusModal.addEventListener("click", (e) => {
    let option = e.target;
    while (option && option !== formCampusModal && !option.classList.contains("form_campus_option")) {
      option = option.parentElement;
    }
    
    if (option && option.classList.contains("form_campus_option")) {
      e.stopPropagation();
      e.preventDefault();
      const value = option.getAttribute("data-value");

      if (value && formCampusNames[value]) {
        selectFormCampus(value, formSelectedCampus, formCampusInput, formCampusModal, formCampusBtn);
      }
      return false;
    }
  });

  // Обработчик для закрытия при клике вне модального окна - с задержкой
  document.addEventListener("click", (e) => {
    // Не закрываем, если клик был внутри модального окна или кнопки
    if (formCampusModal.contains(e.target) || formCampusBtn.contains(e.target)) {
      return;
    }
    
    if (formCampusModal.classList.contains("open")) {
      setTimeout(() => {
        formCampusModal.classList.remove("open");
        formCampusBtn.classList.remove("menu-open");
      }, 10);
    }
  }, false);
  
  // Закрываем выпадающий список при прокрутке
  window.addEventListener("scroll", () => {
    if (formCampusModal.classList.contains("open")) {
      formCampusModal.classList.remove("open");
      formCampusBtn.classList.remove("menu-open");
    }
  }, true);
  
  // Обновляем при изменении размера окна (для переключения между мобильной и десктопной версией)
  window.addEventListener('resize', () => {
    setTimeout(updateBlock7DownloadButton, 150);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDownloadBrochureFormBlock7);
} else {
  initDownloadBrochureFormBlock7();
}

// Дополнительная инициализация антибота после полной загрузки страницы
window.addEventListener('load', () => {
  setTimeout(() => {
    const antibotLabelBlock7El = document.getElementById('antibotLabelBlock7');
    if (!antibotLabelBlock7El) return;
    
    // Проверяем, что вопрос еще не установлен
    const currentText = antibotLabelBlock7El.textContent.trim();
    if (currentText && currentText !== '*' && !currentText.match(/\d+\s*[-–]\s*\d+/)) {
      return; // Вопрос уже установлен
    }
    
    const generateFn = typeof generateAntibot === 'function' ? generateAntibot : 
                       (typeof window.generateAntibot === 'function' ? window.generateAntibot : null);
    const updateFn = typeof updateAntibotLabel === 'function' ? updateAntibotLabel : 
                     (typeof window.updateAntibotLabel === 'function' ? window.updateAntibotLabel : null);
    
    if (generateFn && updateFn) {
      antibot7 = generateFn();
      updateFn(antibotLabelBlock7El, antibot7);
      antibotLabelBlock7El.setAttribute('data-answer', antibot7.answer);
      window.antibot7 = antibot7;
    } else {
      console.warn('generateAntibot or updateAntibotLabel not available for block7');
    }
  }, 500);
});

// Экспортируем функции глобально
window.updateBlock7DownloadButton = updateBlock7DownloadButton;
window.updateBlock7PhoneLimits = updateBlock7PhoneLimits;
window.selectFormCampus = selectFormCampus;
